"use strict";

var cov_2kcce3xsfc = function () {
  var path = "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\core\\resources.js";
  var hash = "7c3390e7ed467724cc6dcd487b41c3e26ad51d45";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\core\\resources.js",
    statementMap: {
      "0": {
        start: {
          line: 6,
          column: 42
        },
        end: {
          line: 20,
          column: 1
        }
      },
      "1": {
        start: {
          line: 11,
          column: 19
        },
        end: {
          line: 13,
          column: 5
        }
      },
      "2": {
        start: {
          line: 11,
          column: 55
        },
        end: {
          line: 13,
          column: 4
        }
      },
      "3": {
        start: {
          line: 16,
          column: 20
        },
        end: {
          line: 18,
          column: 3
        }
      },
      "4": {
        start: {
          line: 17,
          column: 24
        },
        end: {
          line: 17,
          column: 46
        }
      },
      "5": {
        start: {
          line: 19,
          column: 2
        },
        end: {
          line: 19,
          column: 19
        }
      },
      "6": {
        start: {
          line: 22,
          column: 40
        },
        end: {
          line: 56,
          column: 1
        }
      },
      "7": {
        start: {
          line: 27,
          column: 2
        },
        end: {
          line: 55,
          column: 3
        }
      },
      "8": {
        start: {
          line: 28,
          column: 21
        },
        end: {
          line: 28,
          column: 64
        }
      },
      "9": {
        start: {
          line: 31,
          column: 8
        },
        end: {
          line: 31,
          column: 16
        }
      },
      "10": {
        start: {
          line: 32,
          column: 21
        },
        end: {
          line: 32,
          column: 56
        }
      },
      "11": {
        start: {
          line: 33,
          column: 21
        },
        end: {
          line: 37,
          column: 5
        }
      },
      "12": {
        start: {
          line: 34,
          column: 6
        },
        end: {
          line: 36,
          column: 8
        }
      },
      "13": {
        start: {
          line: 38,
          column: 20
        },
        end: {
          line: 42,
          column: 6
        }
      },
      "14": {
        start: {
          line: 43,
          column: 22
        },
        end: {
          line: 45,
          column: 5
        }
      },
      "15": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 46,
          column: 21
        }
      },
      "16": {
        start: {
          line: 49,
          column: 6
        },
        end: {
          line: 51,
          column: 9
        }
      },
      "17": {
        start: {
          line: 52,
          column: 4
        },
        end: {
          line: 52,
          column: 32
        }
      },
      "18": {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 53,
          column: 21
        }
      },
      "19": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 54,
          column: 16
        }
      },
      "20": {
        start: {
          line: 58,
          column: 33
        },
        end: {
          line: 73,
          column: 1
        }
      },
      "21": {
        start: {
          line: 59,
          column: 17
        },
        end: {
          line: 59,
          column: 78
        }
      },
      "22": {
        start: {
          line: 59,
          column: 60
        },
        end: {
          line: 59,
          column: 77
        }
      },
      "23": {
        start: {
          line: 60,
          column: 61
        },
        end: {
          line: 60,
          column: 67
        }
      },
      "24": {
        start: {
          line: 61,
          column: 21
        },
        end: {
          line: 61,
          column: 50
        }
      },
      "25": {
        start: {
          line: 62,
          column: 19
        },
        end: {
          line: 71,
          column: 3
        }
      },
      "26": {
        start: {
          line: 72,
          column: 2
        },
        end: {
          line: 72,
          column: 18
        }
      },
      "27": {
        start: {
          line: 75,
          column: 35
        },
        end: {
          line: 89,
          column: 1
        }
      },
      "28": {
        start: {
          line: 82,
          column: 21
        },
        end: {
          line: 82,
          column: 50
        }
      },
      "29": {
        start: {
          line: 83,
          column: 15
        },
        end: {
          line: 83,
          column: 30
        }
      },
      "30": {
        start: {
          line: 84,
          column: 15
        },
        end: {
          line: 86,
          column: 4
        }
      },
      "31": {
        start: {
          line: 87,
          column: 15
        },
        end: {
          line: 87,
          column: 48
        }
      },
      "32": {
        start: {
          line: 88,
          column: 2
        },
        end: {
          line: 88,
          column: 14
        }
      },
      "33": {
        start: {
          line: 91,
          column: 38
        },
        end: {
          line: 104,
          column: 1
        }
      },
      "34": {
        start: {
          line: 99,
          column: 21
        },
        end: {
          line: 99,
          column: 50
        }
      },
      "35": {
        start: {
          line: 100,
          column: 15
        },
        end: {
          line: 102,
          column: 4
        }
      },
      "36": {
        start: {
          line: 103,
          column: 2
        },
        end: {
          line: 103,
          column: 14
        }
      },
      "37": {
        start: {
          line: 106,
          column: 35
        },
        end: {
          line: 116,
          column: 1
        }
      },
      "38": {
        start: {
          line: 111,
          column: 19
        },
        end: {
          line: 111,
          column: 79
        }
      },
      "39": {
        start: {
          line: 112,
          column: 18
        },
        end: {
          line: 114,
          column: 6
        }
      },
      "40": {
        start: {
          line: 113,
          column: 17
        },
        end: {
          line: 113,
          column: 50
        }
      },
      "41": {
        start: {
          line: 115,
          column: 2
        },
        end: {
          line: 115,
          column: 17
        }
      },
      "42": {
        start: {
          line: 118,
          column: 29
        },
        end: {
          line: 149,
          column: 1
        }
      },
      "43": {
        start: {
          line: 121,
          column: 17
        },
        end: {
          line: 121,
          column: 31
        }
      },
      "44": {
        start: {
          line: 122,
          column: 38
        },
        end: {
          line: 122,
          column: 46
        }
      },
      "45": {
        start: {
          line: 123,
          column: 2
        },
        end: {
          line: 123,
          column: 79
        }
      },
      "46": {
        start: {
          line: 123,
          column: 30
        },
        end: {
          line: 123,
          column: 78
        }
      },
      "47": {
        start: {
          line: 125,
          column: 2
        },
        end: {
          line: 147,
          column: 3
        }
      },
      "48": {
        start: {
          line: 126,
          column: 4
        },
        end: {
          line: 146,
          column: 6
        }
      },
      "49": {
        start: {
          line: 127,
          column: 20
        },
        end: {
          line: 127,
          column: 37
        }
      },
      "50": {
        start: {
          line: 130,
          column: 6
        },
        end: {
          line: 134,
          column: 7
        }
      },
      "51": {
        start: {
          line: 131,
          column: 8
        },
        end: {
          line: 131,
          column: 68
        }
      },
      "52": {
        start: {
          line: 133,
          column: 8
        },
        end: {
          line: 133,
          column: 54
        }
      },
      "53": {
        start: {
          line: 136,
          column: 18
        },
        end: {
          line: 136,
          column: 35
        }
      },
      "54": {
        start: {
          line: 138,
          column: 8
        },
        end: {
          line: 138,
          column: 68
        }
      },
      "55": {
        start: {
          line: 140,
          column: 6
        },
        end: {
          line: 144,
          column: 8
        }
      },
      "56": {
        start: {
          line: 145,
          column: 6
        },
        end: {
          line: 145,
          column: 18
        }
      },
      "57": {
        start: {
          line: 148,
          column: 2
        },
        end: {
          line: 148,
          column: 18
        }
      },
      "58": {
        start: {
          line: 151,
          column: 25
        },
        end: {
          line: 156,
          column: 1
        }
      },
      "59": {
        start: {
          line: 152,
          column: 2
        },
        end: {
          line: 152,
          column: 41
        }
      },
      "60": {
        start: {
          line: 153,
          column: 15
        },
        end: {
          line: 153,
          column: 35
        }
      },
      "61": {
        start: {
          line: 154,
          column: 15
        },
        end: {
          line: 154,
          column: 34
        }
      },
      "62": {
        start: {
          line: 155,
          column: 2
        },
        end: {
          line: 155,
          column: 14
        }
      },
      "63": {
        start: {
          line: 158,
          column: 28
        },
        end: {
          line: 174,
          column: 1
        }
      },
      "64": {
        start: {
          line: 159,
          column: 2
        },
        end: {
          line: 159,
          column: 44
        }
      },
      "65": {
        start: {
          line: 160,
          column: 15
        },
        end: {
          line: 160,
          column: 35
        }
      },
      "66": {
        start: {
          line: 161,
          column: 22
        },
        end: {
          line: 161,
          column: 49
        }
      },
      "67": {
        start: {
          line: 162,
          column: 22
        },
        end: {
          line: 162,
          column: 37
        }
      },
      "68": {
        start: {
          line: 164,
          column: 4
        },
        end: {
          line: 168,
          column: 10
        }
      },
      "69": {
        start: {
          line: 169,
          column: 17
        },
        end: {
          line: 169,
          column: 45
        }
      },
      "70": {
        start: {
          line: 170,
          column: 18
        },
        end: {
          line: 170,
          column: 36
        }
      },
      "71": {
        start: {
          line: 171,
          column: 18
        },
        end: {
          line: 171,
          column: 28
        }
      },
      "72": {
        start: {
          line: 172,
          column: 15
        },
        end: {
          line: 172,
          column: 37
        }
      },
      "73": {
        start: {
          line: 173,
          column: 2
        },
        end: {
          line: 173,
          column: 14
        }
      },
      "74": {
        start: {
          line: 177,
          column: 23
        },
        end: {
          line: 200,
          column: 1
        }
      },
      "75": {
        start: {
          line: 186,
          column: 2
        },
        end: {
          line: 190,
          column: 3
        }
      },
      "76": {
        start: {
          line: 187,
          column: 4
        },
        end: {
          line: 187,
          column: 67
        }
      },
      "77": {
        start: {
          line: 189,
          column: 4
        },
        end: {
          line: 189,
          column: 72
        }
      },
      "78": {
        start: {
          line: 192,
          column: 2
        },
        end: {
          line: 199,
          column: 3
        }
      },
      "79": {
        start: {
          line: 193,
          column: 20
        },
        end: {
          line: 193,
          column: 33
        }
      },
      "80": {
        start: {
          line: 194,
          column: 17
        },
        end: {
          line: 194,
          column: 52
        }
      },
      "81": {
        start: {
          line: 195,
          column: 4
        },
        end: {
          line: 195,
          column: 16
        }
      },
      "82": {
        start: {
          line: 197,
          column: 4
        },
        end: {
          line: 197,
          column: 25
        }
      },
      "83": {
        start: {
          line: 198,
          column: 4
        },
        end: {
          line: 198,
          column: 16
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 6,
            column: 42
          },
          end: {
            line: 6,
            column: 43
          }
        },
        loc: {
          start: {
            line: 10,
            column: 6
          },
          end: {
            line: 20,
            column: 1
          }
        },
        line: 10
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 11,
            column: 37
          },
          end: {
            line: 11,
            column: 38
          }
        },
        loc: {
          start: {
            line: 11,
            column: 55
          },
          end: {
            line: 13,
            column: 4
          }
        },
        line: 11
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 17,
            column: 4
          },
          end: {
            line: 17,
            column: 5
          }
        },
        loc: {
          start: {
            line: 17,
            column: 24
          },
          end: {
            line: 17,
            column: 46
          }
        },
        line: 17
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 22,
            column: 40
          },
          end: {
            line: 22,
            column: 41
          }
        },
        loc: {
          start: {
            line: 26,
            column: 6
          },
          end: {
            line: 56,
            column: 1
          }
        },
        line: 26
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 33,
            column: 43
          },
          end: {
            line: 33,
            column: 44
          }
        },
        loc: {
          start: {
            line: 34,
            column: 6
          },
          end: {
            line: 36,
            column: 8
          }
        },
        line: 34
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 58,
            column: 33
          },
          end: {
            line: 58,
            column: 34
          }
        },
        loc: {
          start: {
            line: 58,
            column: 63
          },
          end: {
            line: 73,
            column: 1
          }
        },
        line: 58
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 59,
            column: 48
          },
          end: {
            line: 59,
            column: 49
          }
        },
        loc: {
          start: {
            line: 59,
            column: 60
          },
          end: {
            line: 59,
            column: 77
          }
        },
        line: 59
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 75,
            column: 35
          },
          end: {
            line: 75,
            column: 36
          }
        },
        loc: {
          start: {
            line: 81,
            column: 6
          },
          end: {
            line: 89,
            column: 1
          }
        },
        line: 81
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 91,
            column: 38
          },
          end: {
            line: 91,
            column: 39
          }
        },
        loc: {
          start: {
            line: 98,
            column: 6
          },
          end: {
            line: 104,
            column: 1
          }
        },
        line: 98
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 106,
            column: 35
          },
          end: {
            line: 106,
            column: 36
          }
        },
        loc: {
          start: {
            line: 110,
            column: 6
          },
          end: {
            line: 116,
            column: 1
          }
        },
        line: 110
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 113,
            column: 4
          },
          end: {
            line: 113,
            column: 5
          }
        },
        loc: {
          start: {
            line: 113,
            column: 17
          },
          end: {
            line: 113,
            column: 50
          }
        },
        line: 113
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 118,
            column: 29
          },
          end: {
            line: 118,
            column: 30
          }
        },
        loc: {
          start: {
            line: 120,
            column: 6
          },
          end: {
            line: 149,
            column: 1
          }
        },
        line: 120
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 123,
            column: 18
          },
          end: {
            line: 123,
            column: 19
          }
        },
        loc: {
          start: {
            line: 123,
            column: 30
          },
          end: {
            line: 123,
            column: 78
          }
        },
        line: 123
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 126,
            column: 25
          },
          end: {
            line: 126,
            column: 26
          }
        },
        loc: {
          start: {
            line: 126,
            column: 37
          },
          end: {
            line: 146,
            column: 5
          }
        },
        line: 126
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 151,
            column: 25
          },
          end: {
            line: 151,
            column: 26
          }
        },
        loc: {
          start: {
            line: 151,
            column: 48
          },
          end: {
            line: 156,
            column: 1
          }
        },
        line: 151
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 158,
            column: 28
          },
          end: {
            line: 158,
            column: 29
          }
        },
        loc: {
          start: {
            line: 158,
            column: 62
          },
          end: {
            line: 174,
            column: 1
          }
        },
        line: 158
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 177,
            column: 23
          },
          end: {
            line: 177,
            column: 24
          }
        },
        loc: {
          start: {
            line: 183,
            column: 6
          },
          end: {
            line: 200,
            column: 1
          }
        },
        line: 183
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 87,
            column: 15
          },
          end: {
            line: 87,
            column: 48
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 87,
            column: 22
          },
          end: {
            line: 87,
            column: 41
          }
        }, {
          start: {
            line: 87,
            column: 44
          },
          end: {
            line: 87,
            column: 48
          }
        }],
        line: 87
      },
      "1": {
        loc: {
          start: {
            line: 111,
            column: 19
          },
          end: {
            line: 111,
            column: 79
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 111,
            column: 51
          },
          end: {
            line: 111,
            column: 67
          }
        }, {
          start: {
            line: 111,
            column: 70
          },
          end: {
            line: 111,
            column: 79
          }
        }],
        line: 111
      },
      "2": {
        loc: {
          start: {
            line: 111,
            column: 19
          },
          end: {
            line: 111,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 111,
            column: 19
          },
          end: {
            line: 111,
            column: 28
          }
        }, {
          start: {
            line: 111,
            column: 32
          },
          end: {
            line: 111,
            column: 48
          }
        }],
        line: 111
      },
      "3": {
        loc: {
          start: {
            line: 125,
            column: 2
          },
          end: {
            line: 147,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 125,
            column: 2
          },
          end: {
            line: 147,
            column: 3
          }
        }, {
          start: {
            line: 125,
            column: 2
          },
          end: {
            line: 147,
            column: 3
          }
        }],
        line: 125
      },
      "4": {
        loc: {
          start: {
            line: 130,
            column: 6
          },
          end: {
            line: 134,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 130,
            column: 6
          },
          end: {
            line: 134,
            column: 7
          }
        }, {
          start: {
            line: 130,
            column: 6
          },
          end: {
            line: 134,
            column: 7
          }
        }],
        line: 130
      },
      "5": {
        loc: {
          start: {
            line: 130,
            column: 10
          },
          end: {
            line: 130,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 130,
            column: 10
          },
          end: {
            line: 130,
            column: 19
          }
        }, {
          start: {
            line: 130,
            column: 23
          },
          end: {
            line: 130,
            column: 40
          }
        }],
        line: 130
      },
      "6": {
        loc: {
          start: {
            line: 138,
            column: 8
          },
          end: {
            line: 138,
            column: 68
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 138,
            column: 40
          },
          end: {
            line: 138,
            column: 56
          }
        }, {
          start: {
            line: 138,
            column: 59
          },
          end: {
            line: 138,
            column: 68
          }
        }],
        line: 138
      },
      "7": {
        loc: {
          start: {
            line: 138,
            column: 8
          },
          end: {
            line: 138,
            column: 37
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 138,
            column: 8
          },
          end: {
            line: 138,
            column: 17
          }
        }, {
          start: {
            line: 138,
            column: 21
          },
          end: {
            line: 138,
            column: 37
          }
        }],
        line: 138
      },
      "8": {
        loc: {
          start: {
            line: 180,
            column: 8
          },
          end: {
            line: 180,
            column: 20
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 180,
            column: 18
          },
          end: {
            line: 180,
            column: 20
          }
        }],
        line: 180
      },
      "9": {
        loc: {
          start: {
            line: 186,
            column: 2
          },
          end: {
            line: 190,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 186,
            column: 2
          },
          end: {
            line: 190,
            column: 3
          }
        }, {
          start: {
            line: 186,
            column: 2
          },
          end: {
            line: 190,
            column: 3
          }
        }],
        line: 186
      },
      "10": {
        loc: {
          start: {
            line: 186,
            column: 6
          },
          end: {
            line: 186,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 186,
            column: 6
          },
          end: {
            line: 186,
            column: 9
          }
        }, {
          start: {
            line: 186,
            column: 13
          },
          end: {
            line: 186,
            column: 29
          }
        }, {
          start: {
            line: 186,
            column: 33
          },
          end: {
            line: 186,
            column: 40
          }
        }],
        line: 186
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0],
      "9": [0, 0],
      "10": [0, 0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "7c3390e7ed467724cc6dcd487b41c3e26ad51d45"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFile = exports.parseChapter = exports.parseBook = exports.extendProject = exports.projectFromProjects = exports.getResourceProjectFile = exports.getResourceManifest = exports.parseResourceLink = exports.resourceFromResourceLink = exports.resourcesFromResourceLinks = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _path = _interopRequireDefault(require("path"));

var _jsYamlParser = _interopRequireDefault(require("js-yaml-parser"));

var _giteaReactToolkit = require("gitea-react-toolkit");

var _usfmJs = _interopRequireDefault(require("usfm-js"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

cov_2kcce3xsfc.s[0]++;

var resourcesFromResourceLinks = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(_ref2) {
    var resourceLinks, reference, config, promises, resources;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            resourceLinks = _ref2.resourceLinks, reference = _ref2.reference, config = _ref2.config;
            cov_2kcce3xsfc.f[0]++;
            promises = (cov_2kcce3xsfc.s[1]++, resourceLinks.map(function (resourceLink) {
              cov_2kcce3xsfc.f[1]++;
              cov_2kcce3xsfc.s[2]++;
              return resourceFromResourceLink({
                resourceLink: resourceLink,
                reference: reference,
                config: config
              });
            })); // Filter invalid resources (those that did not parse).

            cov_2kcce3xsfc.s[3]++;
            _context.next = 6;
            return Promise.all(promises);

          case 6:
            _context.t0 = function (parsedResource) {
              cov_2kcce3xsfc.f[2]++;
              cov_2kcce3xsfc.s[4]++;
              return parsedResource != null;
            };

            _context.next = 9;
            return _context.sent.filter(_context.t0);

          case 9:
            resources = _context.sent;
            cov_2kcce3xsfc.s[5]++;
            return _context.abrupt("return", resources);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function resourcesFromResourceLinks(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.resourcesFromResourceLinks = resourcesFromResourceLinks;
cov_2kcce3xsfc.s[6]++;

var resourceFromResourceLink = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(_ref4) {
    var resourceLink, reference, config, resource, _ref5, projectId, username, repository, tag, manifest, projects, project, _resource, errorMessage;

    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            resourceLink = _ref4.resourceLink, reference = _ref4.reference, config = _ref4.config;
            cov_2kcce3xsfc.f[3]++;
            cov_2kcce3xsfc.s[7]++;
            _context2.prev = 3;
            resource = (cov_2kcce3xsfc.s[8]++, parseResourceLink({
              resourceLink: resourceLink,
              config: config
            }));
            _ref5 = (cov_2kcce3xsfc.s[9]++, resource), projectId = _ref5.projectId, username = _ref5.username, repository = _ref5.repository, tag = _ref5.tag;
            cov_2kcce3xsfc.s[10]++;
            _context2.next = 9;
            return getResourceManifest(resource);

          case 9:
            manifest = _context2.sent;
            projects = (cov_2kcce3xsfc.s[11]++, manifest.projects.map(function (project) {
              cov_2kcce3xsfc.f[4]++;
              cov_2kcce3xsfc.s[12]++;
              return extendProject({
                project: project,
                resource: resource,
                reference: reference
              });
            }));
            cov_2kcce3xsfc.s[13]++;
            _context2.next = 14;
            return projectFromProjects({
              reference: reference,
              projectId: projectId,
              projects: projects
            });

          case 14:
            project = _context2.sent;
            _resource = (cov_2kcce3xsfc.s[14]++, _objectSpread({}, resource, {
              reference: reference,
              manifest: manifest,
              projects: projects,
              project: project
            }));
            cov_2kcce3xsfc.s[15]++;
            return _context2.abrupt("return", _resource);

          case 20:
            _context2.prev = 20;
            _context2.t0 = _context2["catch"](3);
            errorMessage = (cov_2kcce3xsfc.s[16]++, 'scripture-resources-rcl: resources.js: Cannot load resource [' + resourceLink + ']');
            cov_2kcce3xsfc.s[17]++;
            console.error(errorMessage);
            cov_2kcce3xsfc.s[18]++;
            console.error(_context2.t0);
            cov_2kcce3xsfc.s[19]++;
            return _context2.abrupt("return", null);

          case 29:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[3, 20]]);
  }));

  return function resourceFromResourceLink(_x2) {
    return _ref3.apply(this, arguments);
  };
}();

exports.resourceFromResourceLink = resourceFromResourceLink;
cov_2kcce3xsfc.s[20]++;

var parseResourceLink = function parseResourceLink(_ref6) {
  var resourceLink = _ref6.resourceLink,
      config = _ref6.config;
  cov_2kcce3xsfc.f[5]++;
  var parsed = (cov_2kcce3xsfc.s[21]++, resourceLink.split('/').filter(function (string) {
    cov_2kcce3xsfc.f[6]++;
    cov_2kcce3xsfc.s[22]++;
    return string.length > 0;
  }));

  var _ref7 = (cov_2kcce3xsfc.s[23]++, parsed),
      _ref8 = (0, _slicedToArray2.default)(_ref7, 5),
      username = _ref8[0],
      languageId = _ref8[1],
      resourceId = _ref8[2],
      tag = _ref8[3],
      projectId = _ref8[4];

  var repository = (cov_2kcce3xsfc.s[24]++, "".concat(languageId, "_").concat(resourceId));
  var resource = (cov_2kcce3xsfc.s[25]++, {
    resourceLink: resourceLink,
    username: username,
    repository: repository,
    languageId: languageId,
    resourceId: resourceId,
    tag: tag,
    projectId: projectId,
    config: config
  });
  cov_2kcce3xsfc.s[26]++;
  return resource;
};

exports.parseResourceLink = parseResourceLink;
cov_2kcce3xsfc.s[27]++;

var getResourceManifest = /*#__PURE__*/function () {
  var _ref9 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(_ref10) {
    var username, languageId, resourceId, tag, config, repository, path, yaml, json;
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            username = _ref10.username, languageId = _ref10.languageId, resourceId = _ref10.resourceId, tag = _ref10.tag, config = _ref10.config;
            cov_2kcce3xsfc.f[7]++;
            repository = (cov_2kcce3xsfc.s[28]++, "".concat(languageId, "_").concat(resourceId));
            path = (cov_2kcce3xsfc.s[29]++, 'manifest.yaml');
            cov_2kcce3xsfc.s[30]++;
            _context3.next = 7;
            return getFile({
              username: username,
              repository: repository,
              path: path,
              tag: tag,
              config: config
            });

          case 7:
            yaml = _context3.sent;
            json = (cov_2kcce3xsfc.s[31]++, yaml ? (cov_2kcce3xsfc.b[0][0]++, _jsYamlParser.default.safeLoad(yaml)) : (cov_2kcce3xsfc.b[0][1]++, null));
            cov_2kcce3xsfc.s[32]++;
            return _context3.abrupt("return", json);

          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getResourceManifest(_x3) {
    return _ref9.apply(this, arguments);
  };
}();

exports.getResourceManifest = getResourceManifest;
cov_2kcce3xsfc.s[33]++;

var getResourceProjectFile = /*#__PURE__*/function () {
  var _ref11 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(_ref12) {
    var username, languageId, resourceId, tag, path, config, repository, file;
    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            username = _ref12.username, languageId = _ref12.languageId, resourceId = _ref12.resourceId, tag = _ref12.tag, path = _ref12.project.path, config = _ref12.config;
            cov_2kcce3xsfc.f[8]++;
            repository = (cov_2kcce3xsfc.s[34]++, "".concat(languageId, "_").concat(resourceId));
            cov_2kcce3xsfc.s[35]++;
            _context4.next = 6;
            return getFile({
              username: username,
              repository: repository,
              path: path,
              tag: tag,
              config: config
            });

          case 6:
            file = _context4.sent;
            cov_2kcce3xsfc.s[36]++;
            return _context4.abrupt("return", file);

          case 9:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function getResourceProjectFile(_x4) {
    return _ref11.apply(this, arguments);
  };
}();

exports.getResourceProjectFile = getResourceProjectFile;
cov_2kcce3xsfc.s[37]++;

var projectFromProjects = /*#__PURE__*/function () {
  var _ref13 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(_ref14) {
    var reference, projectId, projects, identifier, project;
    return _regenerator.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            reference = _ref14.reference, projectId = _ref14.projectId, projects = _ref14.projects;
            cov_2kcce3xsfc.f[9]++;
            identifier = (cov_2kcce3xsfc.s[38]++, (cov_2kcce3xsfc.b[2][0]++, reference) && (cov_2kcce3xsfc.b[2][1]++, reference.bookId) ? (cov_2kcce3xsfc.b[1][0]++, reference.bookId) : (cov_2kcce3xsfc.b[1][1]++, projectId));
            project = (cov_2kcce3xsfc.s[39]++, projects.filter(function (project) {
              cov_2kcce3xsfc.f[10]++;
              cov_2kcce3xsfc.s[40]++;
              return project.identifier === identifier;
            })[0]);
            cov_2kcce3xsfc.s[41]++;
            return _context5.abrupt("return", project);

          case 6:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function projectFromProjects(_x5) {
    return _ref13.apply(this, arguments);
  };
}();

exports.projectFromProjects = projectFromProjects;
cov_2kcce3xsfc.s[42]++;

var extendProject = function extendProject(_ref15) {
  var project = _ref15.project,
      resource = _ref15.resource,
      reference = _ref15.reference;
  cov_2kcce3xsfc.f[11]++;

  var _project = (cov_2kcce3xsfc.s[43]++, _objectSpread({}, project));

  var _ref16 = (cov_2kcce3xsfc.s[44]++, resource),
      projectId = _ref16.projectId,
      resourceLink = _ref16.resourceLink;

  cov_2kcce3xsfc.s[45]++;
  _project.file = /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6() {
    return _regenerator.default.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            cov_2kcce3xsfc.f[12]++;
            cov_2kcce3xsfc.s[46]++;
            return _context6.abrupt("return", getResourceProjectFile(_objectSpread({}, resource, {
              project: project
            })));

          case 3:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  cov_2kcce3xsfc.s[47]++;

  if (project.path.match(/\.usfm$/)) {
    cov_2kcce3xsfc.b[3][0]++;
    cov_2kcce3xsfc.s[48]++;
    _project.parseUsfm = /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7() {
      var start, json, end, identifier;
      return _regenerator.default.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              cov_2kcce3xsfc.f[13]++;
              start = (cov_2kcce3xsfc.s[49]++, performance.now());
              cov_2kcce3xsfc.s[50]++;

              if (!((cov_2kcce3xsfc.b[5][0]++, reference) && (cov_2kcce3xsfc.b[5][1]++, reference.chapter))) {
                _context7.next = 11;
                break;
              }

              cov_2kcce3xsfc.b[4][0]++;
              cov_2kcce3xsfc.s[51]++;
              _context7.next = 8;
              return parseChapter({
                project: _project,
                reference: reference
              });

            case 8:
              json = _context7.sent;
              _context7.next = 16;
              break;

            case 11:
              cov_2kcce3xsfc.b[4][1]++;
              cov_2kcce3xsfc.s[52]++;
              _context7.next = 15;
              return parseBook({
                project: _project
              });

            case 15:
              json = _context7.sent;

            case 16:
              end = (cov_2kcce3xsfc.s[53]++, performance.now());
              identifier = (cov_2kcce3xsfc.s[54]++, (cov_2kcce3xsfc.b[7][0]++, reference) && (cov_2kcce3xsfc.b[7][1]++, reference.bookId) ? (cov_2kcce3xsfc.b[6][0]++, reference.bookId) : (cov_2kcce3xsfc.b[6][1]++, projectId));
              cov_2kcce3xsfc.s[55]++;
              console.log("fetch & parse ".concat(resourceLink, " ").concat(identifier, ": ").concat((end - start).toFixed(3), "ms"));
              cov_2kcce3xsfc.s[56]++;
              return _context7.abrupt("return", json);

            case 22:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));
  } else {
    cov_2kcce3xsfc.b[3][1]++;
  }

  cov_2kcce3xsfc.s[57]++;
  return _project;
};

exports.extendProject = extendProject;
cov_2kcce3xsfc.s[58]++;

var parseBook = /*#__PURE__*/function () {
  var _ref19 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(_ref20) {
    var project, usfm, json;
    return _regenerator.default.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            project = _ref20.project;
            cov_2kcce3xsfc.f[14]++;
            cov_2kcce3xsfc.s[59]++;
            console.log('parseBook usfmJS.toJSON');
            cov_2kcce3xsfc.s[60]++;
            _context8.next = 7;
            return project.file();

          case 7:
            usfm = _context8.sent;
            json = (cov_2kcce3xsfc.s[61]++, _usfmJs.default.toJSON(usfm));
            cov_2kcce3xsfc.s[62]++;
            return _context8.abrupt("return", json);

          case 11:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function parseBook(_x6) {
    return _ref19.apply(this, arguments);
  };
}();

exports.parseBook = parseBook;
cov_2kcce3xsfc.s[63]++;

var parseChapter = /*#__PURE__*/function () {
  var _ref21 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9(_ref22) {
    var project, reference, usfm, thisChapter, nextChapter, regexpString, regexp, matches, chapter, json;
    return _regenerator.default.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            project = _ref22.project, reference = _ref22.reference;
            cov_2kcce3xsfc.f[15]++;
            cov_2kcce3xsfc.s[64]++;
            console.log('parseChapter usfmJS.toJSON');
            cov_2kcce3xsfc.s[65]++;
            _context9.next = 7;
            return project.file();

          case 7:
            usfm = _context9.sent;
            thisChapter = (cov_2kcce3xsfc.s[66]++, parseInt(reference.chapter));
            nextChapter = (cov_2kcce3xsfc.s[67]++, thisChapter + 1);
            regexpString = (cov_2kcce3xsfc.s[68]++, '(\\\\c\\s*' + thisChapter + '\\s*(.*?\n?)*?)(?:(\\\\c\\s*' + nextChapter + '|$))');
            regexp = (cov_2kcce3xsfc.s[69]++, new RegExp(regexpString, ''));
            matches = (cov_2kcce3xsfc.s[70]++, usfm.match(regexp));
            chapter = (cov_2kcce3xsfc.s[71]++, matches[1]);
            json = (cov_2kcce3xsfc.s[72]++, _usfmJs.default.toJSON(chapter));
            cov_2kcce3xsfc.s[73]++;
            return _context9.abrupt("return", json);

          case 17:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));

  return function parseChapter(_x7) {
    return _ref21.apply(this, arguments);
  };
}(); // https://git.door43.org/unfoldingword/en_ult/raw/branch/master/manifest.yaml


exports.parseChapter = parseChapter;
cov_2kcce3xsfc.s[74]++;

var getFile = /*#__PURE__*/function () {
  var _ref23 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee10(_ref24) {
    var username, repository, _ref24$path, urlPath, tag, config, url, _config, data;

    return _regenerator.default.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            username = _ref24.username, repository = _ref24.repository, _ref24$path = _ref24.path, urlPath = _ref24$path === void 0 ? (cov_2kcce3xsfc.b[8][0]++, '') : _ref24$path, tag = _ref24.tag, config = _ref24.config;
            cov_2kcce3xsfc.f[16]++;
            cov_2kcce3xsfc.s[75]++;

            if ((cov_2kcce3xsfc.b[10][0]++, tag) && (cov_2kcce3xsfc.b[10][1]++, tag !== 'master') && (cov_2kcce3xsfc.b[10][2]++, urlPath)) {
              cov_2kcce3xsfc.b[9][0]++;
              cov_2kcce3xsfc.s[76]++;
              url = _path.default.join(username, repository, 'raw/tag', tag, urlPath);
            } else {
              cov_2kcce3xsfc.b[9][1]++;
              cov_2kcce3xsfc.s[77]++;
              url = _path.default.join(username, repository, 'raw/branch/master', urlPath);
            }

            cov_2kcce3xsfc.s[78]++;
            _context10.prev = 5;
            _config = (cov_2kcce3xsfc.s[79]++, _objectSpread({}, config)); // prevents gitea-react-toolkit from modifying object

            cov_2kcce3xsfc.s[80]++;
            _context10.next = 10;
            return (0, _giteaReactToolkit.get)({
              url: url,
              config: _config
            });

          case 10:
            data = _context10.sent;
            cov_2kcce3xsfc.s[81]++;
            return _context10.abrupt("return", data);

          case 15:
            _context10.prev = 15;
            _context10.t0 = _context10["catch"](5);
            cov_2kcce3xsfc.s[82]++;
            console.error(_context10.t0);
            cov_2kcce3xsfc.s[83]++;
            return _context10.abrupt("return", null);

          case 21:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[5, 15]]);
  }));

  return function getFile(_x8) {
    return _ref23.apply(this, arguments);
  };
}();

exports.getFile = getFile;